// extracted by mini-css-extract-plugin
module.exports = {"storeSongsPage":"_storeSongsPage_storeSongsPage__2X_m_"};